module.exports = __webpack_public_path__ + "static/media/baby_chair.bac5a70f.svg";